import { TranslationObject } from '@ngx-translate/core';

const en: TranslationObject = {
  en: 'English',
  app: {
    test: 'This is a test label',
    title: 'SWD - Start Work Discipline',
    welcomeMessage: 'Welcome to SWD Web Application',
    forms: {
      ok: 'Ok',
      cancel: 'Cancel',
      create: 'Create',
      continue: 'Continue',
      labels: {
        businessUnit: 'Business Unit',
        placeholderBusinessUnit: 'Select a business unit',
        user: 'User',
        name: 'Name',
        description: 'Description',
        placeHolderDescription: 'Enter a description',
        placeHolderReviewType: 'Select a review type',
        mandatory: 'Mandatory',
      },
      unsavedChangesWarning:
        'Unsaved changes have been detected. If you leave this page, the modifications you made will be lost.<br>Do you want to continue?',
    },
    warnings: {
      removeOwnAdminRights: 'You have removed your admin rights. Please refresh the web page to prevent misfunction.',
      removeOwnAccess: 'You have removed your access. Please refresh the web page to prevent misfunction.',
    },
  },
  navigation: {
    startWorkDone: 'Observations',
    category: 'Categories',
    businessUnits: 'Business Units',
    administration: 'Administration',
    sysAdmins: 'System Administrators',
    users: 'Users',
    areas: 'Areas',
    errorReductionTools: 'Error Reduction Tools',
    nonBadgedPersons: 'Non-Badged People Observed',
  },
  startWorkDoneList: {
    title: 'Observations',
    noStartWorkDone: 'Select a Business Unit, Area, Sub Area, Category and Person Observed to display records',
    emptyList: 'No Start Work Discipline records found for the selected filters',
    id: 'ID',
    question: 'Control',
    answer: 'Response',
    score: 'Score',
    comment: 'Comment',
    errorReductionTool: 'Error Reduction Tool',
    updatedBy: 'Updated By',
    updatedDate: 'Updated Date',
    createNewStartWorkDone: 'create new observation',
    reviewType: 'Review Type',
    area: 'Area',
    observationDate: 'Observation Date',
    subArea: 'Sub Area',
    category: 'Category',
    placeholderArea: 'Select an area',
    placeholderSubArea: 'Select a sub area',
    placeholderCategory: 'Select a category',
    addQuestion: 'Add Control',
    description: 'Description',
    subSection: 'Sub Section',
    userSearch: 'Person Observed',
    userSearchPlaceholder: 'Search by name or email...',
    supervisor: 'Supervisor',
    noSupervisor: 'No supervisor found',
    nonBadgedPersonObserved: 'Non-Badged Person Observed',
    placeholderNonBadgedPersonObserved: 'Select a non-badged person',
    personSelectionConflict:
      'Only one of the following fields may be populated: Person Observed or Non-Badged Person Observed.',
    clearAnswer: 'Clear Answer',
    deleteQuestion: 'Delete Control',
    editQuestion: 'Edit Control',
    editQuestionHeader: 'Edit Control',
    deleteQuestionTitle: 'Delete Control',
    confirmDeleteQuestion:
      '<span>Are you sure you want to delete this control?</span><br><br><span><b>Control:</b> {{ description }}</span>',
    generateReport: 'Generate Report',
    completeReview: 'Complete and Send Report',
    generateReportInfoMessage:
      'Your report is being generated and will download automatically. This may take a few moments.',
    generateSuccessMessage: 'Report generated successfully',
    reviewSuccessMessage: 'SWD observation report sent successfully',
    sendEmail: 'Send Email',
    emailSuccessMessage: 'Email sent successfully',
    emailErrorMessage: 'Failed to send email',
    tableColumns: {
      businessUnit: 'Business Unit',
      category: 'Category',
      subArea: 'Sub Area',
      area: 'Area',
      user: 'Person Observed',
      nonBadgedPerson: 'Non-Badged Person Observed',
      supervisor: 'Supervisor',
      observationDate: 'Observation Date',
      totalScore: 'Total Score',
      createdBy: 'Observer',
    },
    viewEdit: 'View / Edit',
  },
  startWorkDoneDetail: {
    title: 'Observation',
    details: 'General Information',
    notFound: 'Start Work Discipline record not found',
    accessDenied: 'You do not have access to this observation.',
    saveSuccess: 'Record updated successfully',
    editInfo: 'Edit Info',
    saveInfo: 'Save Info',
    errorReductionTools: 'Error Reduction Tools',
    noControls: 'No controls found. Add controls to this category first.',
    totalScore: 'Total Score',
    deleteObservation: 'Delete Observation',
    deleteConfirmTitle: 'Delete Observation',
    deleteConfirmMessage: 'Are you sure you want to delete this observation? This action cannot be undone.',
    deleteSuccess: 'Observation deleted successfully',
    noObservationDate: 'No Observation Date has been selected. Please select a date before completing this review.',
  },
  categoryList: {
    title: 'Categories',
  },
  admin: {
    sysAdminList: {
      title: 'System Administrators',
      addSysAdmin: 'add sys admin',
      fullName: 'full name',
      email: 'email',
      dialogs: {
        removeAccessHeader: 'Confirmation',
        removeAccessMessage: 'Are you sure you want to remove system admin access for: [{{firstName}} {{lastName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Business Units',
      addBusinessUnit: 'add business unit',
      tableTitle: 'business unit',
      noBusinessUnits: 'No business units found.',
      dialogs: {
        createHeader: 'Create Business Unit',
        namePlaceholder: 'Enter a name',
      },
    },
    businessUnitEdit: {
      title: 'Edit Business Unit',
    },
    errorReductionTools: {
      title: 'Error Reduction Tools',
      addErt: 'add error reduction tool',
      tableTitle: 'error reduction tool',
      noErts: 'No error reduction tools found.',
      dialogs: {
        createHeader: 'Create Error Reduction Tool',
        editHeader: 'Edit Error Reduction Tool',
        namePlaceholder: 'Enter a name',
        deleteTitle: 'Delete Error Reduction Tool',
        deleteMessage: 'Are you sure you want to delete the error reduction tool <strong>{{name}}</strong>?',
        deleteSuccess: 'Error reduction tool deleted successfully.',
        deleteConflict: 'This error reduction tool cannot be deleted because it is attached to one or more controls.',
      },
    },
    nonBadgedPersons: {
      title: 'Non-Badged People Observed',
      addPerson: 'add non-badged person observed',
      importPeople: 'import non-badged permit users',
      noPeople: 'No non-badged people found.',
      columns: {
        name: 'non-badged person observed',
        supervisorEmail: 'supervisor email',
        supervisorName: 'supervisor name',
      },
      dialogs: {
        createHeader: 'Add non-badged person observed',
        editHeader: 'Edit non-badged person observed',
        nameLabel: 'Non-badged Person',
        nameRequired: 'Name is required',
        supervisorLabel: 'Supervisor',
        supervisorPlaceholder: 'Search by name or email...',
        supervisorRequired: 'Email is required',
        deleteTitle: 'Delete Non-Badged Person',
        deleteMessage: 'Are you sure you want to delete the non-badged person <strong>{{name}}</strong>?',
        deleteSuccess: 'Non-badged person deleted successfully.',
        deleteConflict:
          'This non-badged person cannot be deleted because they have participated in one or more observations.',
        importHeader: 'Import Non-Badged observed people',
        attachDocument: 'Attach document',
        uploadedOn: 'Uploaded {{date}}',
        removeFile: 'Remove file',
        invalidFile: 'Select one Excel (.xlsx) file of 5 MB or smaller.',
        importFailed: 'Nothing was imported. Fix these errors and try again:',
        importSuccess: 'Import complete. Imported: {{imported}}. Duplicates skipped: {{skipped}}.',
      },
    },
    areas: {
      title: 'Areas',
      areasTitle: 'Areas',
      subAreasTitle: 'Sub Areas',
      addArea: 'Add Area',
      addSubArea: 'Add Sub Area',
      areaName: 'Name',
      subAreaName: 'Sub Areas',
      category: 'Category',
      noAreas: 'No areas available.',
      noSubAreas: 'No sub areas available.',
      selectAreaMessage: 'Select an area to manage its sub areas.',
      dialogs: {
        createAreaHeader: 'Create Area',
        editAreaHeader: 'Edit Area',
        createSubAreaHeader: 'Create Sub Area',
        editSubAreaHeader: 'Edit Sub Area',
        namePlaceholder: 'Enter a name',
        category: 'Category',
        categoryPlaceholder: 'Select a category (optional)',
        deleteAreaTitle: 'Delete Area',
        deleteAreaMessage: 'Are you sure you want to delete the area <strong>{{name}}</strong>?',
        deleteAreaLinkedRecords: 'Cannot delete this area because it has linked Start Work Discipline records.',
        deleteSubAreaTitle: 'Delete Sub Area',
        deleteSubAreaMessage: 'Are you sure you want to delete the sub area <strong>{{name}}</strong>?',
        deleteSubAreaLinkedRecords: 'Cannot delete this sub area because it has linked Start Work Discipline records.',
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Not Registered',
      forms: {
        submit: 'Request Access',
      },
      dialogTitle: 'Request Access',
      dialogSubtitle: 'You are about to request access for <strong>{{name}}</strong>, you want to proceed?',
      reloadWarning:
        'If you visit this page but already have access, please click the following link to reload, otherwise contact support.',
      reload: 'reload',
    },
    pendingAccess: {
      title: 'Hi, your Access Request is in Progress',
      reloadWarning:
        'If you visit this page but already have access, please click the following link to reload, otherwise contact support.',
      reload: 'reload',
    },
  },
  header: {
    logoAlt: 'CVX Logo',
    userAvatarAlt: 'User Avatar',
    unknownUser: 'Unknown',
  },
  footer: {
    text: 'Chevron Corporation. All rights reserved.',
    version: 'SWD v{{ version }}',
  },
  category: {
    title: 'Categories',
    create: 'Create',
    name: 'Name',
    description: 'Description',
    actions: 'Actions',
    edit: 'Edit',
    manage: 'Manage',
    delete: 'Delete',
    confirmDelete:
      '<span>Are you sure you want to delete this category?</span><br><br><span>Name: {{ name }}<br>Description: {{ description }}</span>',
    noCategories: 'No categories available.',
    titleCreate: 'Create Category',
    createNew: 'Create New',
    selectPlaceholder: 'Select one...',
    titleEdit: 'Edit Category',
    titleDelete: 'Delete Category',
    deletedSuccessfully: 'Category deleted successfully',
    importCategory: 'Import Category',
    importCategoryTitle: 'Import Category to ',
    selectCategoryType: 'Select Category Type',
    confirm: 'Confirm',
    importSuccessMessage: 'Category imported successfully',
    manageControls: 'Manage Controls',
    noControls: 'No controls available.',
    selectBusinessUnit: 'Select a business unit to display your categories',
    importCategoriesTitle: 'Import Categories',
    import: 'Import',
  },
  categoryManage: {
    title: 'Manage Content of {{ description }}',
    questionsTitle: 'Controls',
    addQuestionAction: 'add control',
    questionName: 'Control',
    questionNamePlaceholder: 'Enter the control text',
    errorReductionTools: 'Error Reduction Tools',
    ertPlaceholder: 'Select error reduction tools',
    noQuestions: 'No controls found. Add a control to start.',
    sectionsTitle: 'Error Reduction Tools',
    subSectionsTitle: 'Subsections',
    addSectionAction: 'add tool',
    mandatoryLabel: 'Mandatory',
    createNewSubsectionAction: 'add controls group',
    emptySubSectionsMessage:
      '<p>There is no content available for this section.</p><p>Please add a subsection to start.</p>',
    itemDescriptionTableHeader: 'description',
    createNewItemAction: 'Add control',
    createSectionHeader: 'Create Section',
    editSectionHeader: 'Edit Section',
    confirmDeleteSection: 'Are you sure you want to delete the section <strong>{{description}}</strong>?',
    createSubSectionHeader: 'Add controls group',
    editSubSectionHeader: 'Edit subsection',
    createQuestionTitle: 'Create Control',
    ShouldAddCommentToQuestion: 'The user should add a comment to any control answered with N/A',
    deleteQuestionTitle: 'Delete Control',
    confirmDeleteQuestion:
      '<span>Are you sure you want to delete this control?</span><br><br><span><b>Description:</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Are you sure you want to delete the subsection <strong>{{description}}</strong>?',
    deleteSectionHeader: 'Delete Section',
    deleteSubSectionHeader: 'Delete Subsection',
    editQuestionTitle: 'Edit Control',
    defaultSubSectionName: 'Controls',
  },
  common: {
    selectAnswer: 'Select answer',
    noAttempt: 'No Attempt',
    needsImprovement: 'Needs Improvement',
    meetsExpectations: 'Meets Expectations',
    exceedsExpectations: 'Exceed Expectations',
    save: 'Save',
    view: 'View',
    back: 'Back',
    businessUnit: 'Business Unit',
    name: 'Name',
    code: 'Code',
    cancel: 'Cancel',
    forbidActionErrorMessage: 'User is not authorized to perform this action',
    genericErrorMessage: 'An unexpected error has occurred. Please try again later.',
    savedSuccessfully: 'Saved successfully',
    delete: 'Delete',
    deletedSuccessfully: 'Deleted successfully',
    edit: 'Edit',
    leaveWithOutSaving: 'Leave without saving',
    language: 'Language',
    createdBy: 'Created by',
    updatedBy: 'Updated by',
    updatedDate: 'Updated Date',
    errors: {
      failedToSubmit: 'Failed to submit response. Please try again.',
    },
  },
  serverError: {
    title: 'Server Unavailable',
    message: 'Unable to connect to the server. Please check your network connection or try again later.',
    returnHome: 'Return to Home',
  },
  pageNotFound: {
    title: 'Page Not Found',
    message: 'The page you are looking for does not exist.',
    returnHome: 'Return to Home',
  },
  unauthorized: {
    title: 'Unauthorized Access',
    message: 'You do not have permission to access this page.',
    returnHome: 'Return to Home',
  },
  paginator: {
    previous: 'Previous',
    next: 'Next',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} of {{totalRecords}}',
  },
  usersList: {
    title: 'Users',
    forms: {
      displayInactiveUsers: 'display inactive users',
    },
    actions: {
      addNewUser: 'Add new user',
      grantAccess: 'grant access',
    },
    table: {
      fullName: 'full name',
      email: 'email',
      admin: 'admin',
    },
    noUsers: 'No users available',

    dialogs: {
      removeAccessHeader: 'Confirmation',
      removeAccessMessage: 'Are you sure you want to remove access for: [{{fullName}}]?',
    },
  },
  comments: {
    title: 'Comments',
    addComment: 'add comment',
    noComments: 'No comments',
    dialogs: {
      configureComment: 'Comment',
      deleteCommentHeader: 'Delete Comment',
      deleteCommentMessage: 'Are you sure that you want to perform this action?',
    },
    comment: 'Comment',
    instructions: {
      title: 'Comments should include:',
      observed: 'What was observed',
      coaching: 'What coaching was provided',
      action: 'What action was taken to resolve any issues',
      feedback: 'What positive feedback was given for exceeding expectations',
    },
  },
  actionItems: {
    title: 'Action Items',
    id: 'ID',
    addActionItem: 'Add Action Item',
    actionTitle: 'Title',
    assignee: 'Assignee',
    date: 'Date',
    comment: 'Comment',
    priority: 'Priority',
    dialogs: {
      configureActionItem: 'Configure Action Item',
      configureComment: 'Comment',
      deleteActionItemHeader: 'Delete Action Item',
      deleteActionItemMessage: 'Are you sure that you want to perform this action?',
    },
  },
  features: {
    startWorkDone: {
      labels: {
        observationComment: 'Observation Comment',
      },
      placeholders: {
        enterComment: 'Enter your coaching feedback or context for this response...',
      },
      messages: {
        responseSubmitted: 'Response submitted successfully',
        commentRequired: 'A comment is required for this response type',
      },
      responseAnswers: {
        noAttempt: 'No Attempt',
        needsImprovement: 'Needs Improvement',
        meetsExpectations: 'Meets Expectations',
        exceedsExpectations: 'Exceed Expectations',
        notApplicable: 'Not Applicable',
      },
    },
  },
};
export default en;
